import connectCentrifugo from './centrifugo_worker';

connectCentrifugo();
